// extracted by mini-css-extract-plugin
export var cardIcon = "_6w-5";
export var cardIconUnframed = "_6w-9";
export var checkboxCard = "_6w-0";
export var checkboxCardSelected = "_6w-4";
export var disabled = "_6w-2";
export var interactive = "_6w-1";
export var outerBorder = "_6w-3";
export var spacerMedium = "_6w-8";
export var spacerSmall = "_6w-7";
export var spacerXsmall = "_6w-6";